// extracted by mini-css-extract-plugin
module.exports = {"container":"VerifyBankWithPlaidScreen_container__2zh5z","visuallyHidden":"VerifyBankWithPlaidScreen_visuallyHidden__iJXc4"};